import Dashboard from "../components/dashboard/Dashboard";
import InstructorNavbar from "../components/instructor/InstructorNavbar";
// import Navbar from "../components/layout/Navbar";


const InstructorDashboardPage = () => {
    return ( 
        <>
        <InstructorNavbar/>
        <Dashboard/>
        </>
     );
}
 
export default InstructorDashboardPage;